import PropTypes from "prop-types";
/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */

import React from "react";

import StyledText from "ae-base/Base/StyledText";
import InputLabel from "../Inputs/Layout/InputLabel";
import InputContainer from "../Inputs/Layout/InputContainer";

export default function OutputDays(props, context) {
	var localize = context.localize;
	var localizeFrom = context.localizeFrom;
	var schema = props.schema;
	var data = props.data;
	var style = props.style;

	var value_description = schema.value_description || null;
	var value_localization = schema.value_localization || null;

	/**
	 * 'reduce' picks out the days of the week that are 'true'.
	 * 'map' handles the the localization.
	 */
	var week = Object.keys(data).reduce(function (acc, curr) {
		if (data[curr]) acc = acc.concat(curr);
		if (acc.indexOf("all") >= 0) acc = ["all"];
		return acc;
	}, []).map(function (item) {
		if(value_localization){
			return (localizeFrom(value_localization, item) || item) + " ";
		} else if (value_description) {
			return (localize(value_description + "." + item) || item) + " ";
		}
		return item + " ";
	});

	return (
		<InputContainer style={props.style}><InputLabel schema={schema} title={props.title} contrast={props.contrast} />
			<StyledText style={style} light contrast={props.contrast} black={!props.contrast}>
				{week}
			</StyledText>
		</InputContainer>
	);
}

OutputDays.contextTypes = {
	localize: PropTypes.func,
	localizeFrom: PropTypes.func
};
